import { FunctionComponent, ReactNode } from "react";

import CategoriesContext from "@context/context/categories-context";

interface Props {
  categories: string[] | null;
  internalCategories: string[] | null;
  primaryCategoryNodeId?: string;
  primarySuperCatNodeId?: string;
  superCatNodeId?: string;
  categoryNodeId?: string;
  children?: ReactNode;
}

const CategoriesProvider: FunctionComponent<Props> = ({
  children,
  categories,
  primaryCategoryNodeId,
  primarySuperCatNodeId,
  superCatNodeId,
  categoryNodeId,
  internalCategories,
}) => {
  return (
    <CategoriesContext.Provider
      value={{
        categories,
        internalCategories,
        primaryCategoryNodeId,
        primarySuperCatNodeId,
        superCatNodeId,
        categoryNodeId,
      }}
    >
      {children}
    </CategoriesContext.Provider>
  );
};

export default CategoriesProvider;
